import { hotList } from '@/mocks/hotList';
import type { HotItem } from '@/pages/home/types';

const items: HotItem[] = hotList;

const rankStyle = (rank: number) => {
  if (rank === 1) return 'bg-primary-500 text-background-50 dark:text-foreground-950';
  if (rank === 2) return 'bg-accent-500 text-background-900';
  if (rank === 3) return 'bg-secondary-500 text-background-50 dark:text-foreground-950';
  return 'bg-background-200 text-foreground-600';
};

export default function HotList() {
  const lead = items[0];

  return (
    <section id="today" className="w-full px-4 md:px-8 py-14 md:py-20 scroll-mt-20 bg-background-50">
      <div className="mb-8 md:mb-10 max-w-2xl">
        <span className="inline-flex items-center gap-1.5 text-xs font-bold text-primary-600 bg-primary-100 px-3 py-1.5 rounded-full mb-4">
          <i className="ri-fire-line"></i> 今日爆料榜
        </span>
        <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug mb-3">
          今天热度最高的 8 条爆料
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
          榜单根据话题讨论度与信息更新频率整理，每条都附上简要说明。部分内容仍在变化中，请以官方信息为准。
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
        <article className="lg:col-span-1 rounded-lg overflow-hidden bg-background-100 border border-background-200 flex flex-col">
          <div className="relative w-full h-[240px] md:h-[280px]">
            <img
              src="https://readdy.ai/api/search-image?query=cinematic%20moody%20editorial%20photograph%20of%20a%20late%20night%20city%20rooftop%20with%20deep%20crimson%20and%20amber%20city%20glow%20and%20dramatic%20shadows%2C%20strong%20contrast%20and%20soft%20film%20grain%2C%20stylized%20abstract%20urban%20mystery%20scene&width=800&height=1000&seq=baoliao-lead-story-01&orientation=portrait"
              alt="今日头条爆料主视觉"
              title="今日头条爆料 · 爆料网"
              className="w-full h-full object-cover object-top"
            />
            <span className="absolute top-3 left-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-bold">
              <i className="ri-flashlight-fill"></i> 今日头条
            </span>
          </div>
          <div className="p-4 md:p-5 flex-1 flex flex-col">
            <div className="flex items-center gap-2 mb-2">
              <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 text-xs font-bold">
                {lead.category}
              </span>
              <span className="text-xs text-foreground-500">
                <i className="ri-fire-line mr-1 text-primary-500"></i>
                {lead.heat}
              </span>
            </div>
            <h3 className="font-heading text-lg font-bold text-foreground-950 leading-snug mb-2">{lead.title}</h3>
            <p className="text-sm text-foreground-600 leading-relaxed">{lead.summary}</p>
          </div>
        </article>

        <div className="lg:col-span-2 flex flex-col gap-3">
          {items.map((item) => (
            <article
              key={item.rank}
              className="group flex gap-3 md:gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <span
                className={`flex-shrink-0 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-md font-heading font-black text-base ${rankStyle(
                  item.rank,
                )}`}
              >
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium">
                    {item.category}
                  </span>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-fire-line mr-1 text-primary-500"></i>
                    热度 {item.heat}
                  </span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 leading-snug mb-1 group-hover:text-primary-700 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed hidden sm:block">
                  {item.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}